module.exports = {
  contextSeparator: '//context:',
};
